import React, { useState } from "react";
import { Link } from "react-router-dom";
import logo from "../assets/logo.png";

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <nav className="fixed w-full z-50 bg-black/30 backdrop-blur-lg text-white">
      <div className="max-w-7xl mx-auto flex justify-between items-center px-6 py-4">

        {/* LOGO */}
        <div className="flex items-center gap-2">
          <img src={logo} alt="logo" className="w-10" />
          <span className="font-bold text-lg">TheLogicWaves</span>
        </div>

        {/* DESKTOP MENU */}
        <div className="hidden md:flex gap-8">
          <Link to="/" className="hover:text-purple-400">Home</Link>
          <Link to="/about" className="hover:text-purple-400">About</Link>
          <Link to="/services" className="hover:text-purple-400">Services</Link>
          <Link to="/portfolio" className="hover:text-purple-400">Portfolio</Link>
           <Link to="/blog" className="hover:text-purple-400">Blog</Link>
          <Link to="/contact" className="hover:text-purple-400">Contact</Link>
         
        </div>

        {/* MOBILE BUTTON */}
        <button onClick={() => setMenuOpen(!menuOpen)} className="md:hidden">
          ☰
        </button>
      </div>

      {/* MOBILE MENU */}
      {menuOpen && (
        <div className="md:hidden bg-black/90 px-6 pb-4 flex flex-col gap-4">
          <Link to="/">Home</Link>
          <Link to="/about">About</Link>
          <Link to="/services">Services</Link>
          <Link to="/portfolio">Portfolio</Link>
          <Link to="/Blog">Blog</Link>
          <Link to="/contact">Contact</Link>
        </div>
      )}
    </nav>
  );
};

export default Navbar;